export class KeyspacesTableRestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsKeyspaces",
            "baseName": "awsKeyspaces",
            "type": "AwsKeyspacesDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KeyspacesTableRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
